import check from './CheckPermissions';

export default authority => !!check(authority, true, false);
